<template>
  <v-layout
    v-if="prevNextBtns"
    align-center
    justify-end
  >
    <v-tooltip
      :open-delay="1500"
      bottom
    >
      <v-btn
        slot="activator"
        :disabled="prevDisabled"
        icon
        flat
        @click="prev"
      >
        <v-icon color="iconColor">
          fast_rewind
        </v-icon>
      </v-btn>
      <span>Previous</span>
    </v-tooltip>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="date"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <p
        slot="activator"
        class="mb-0"
      >
        <v-flex
          d-flex
          align-center
        >
          <v-icon color="iconColor">
            event
          </v-icon>
          <span class="pl-2 subheading">
            {{ formattedDate }}
          </span>
        </v-flex>
      </p>
      <v-date-picker
        v-model="date"
        :type="type"
        :min="min"
        :max="max"
        no-title
        scrollable
      >
        <v-spacer />
        <v-btn
          flat
          color="primary"
          @click="menu = false"
        >
          Cancel
        </v-btn>
        <v-btn
          flat
          color="primary"
          @click="_okTap(date)"
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>
    <v-tooltip
      :open-delay="1500"
      bottom
    >
      <v-btn
        slot="activator"
        :disabled="nextDisabled"
        icon
        flat
        @click="next"
      >
        <v-icon color="iconColor">
          fast_forward
        </v-icon>
      </v-btn>
      <span>Next</span>
    </v-tooltip>
  </v-layout>
  <div
    v-else
  >
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="date"
      lazy
      transition="scale-transition"
      offset-y
      min-width="150px"
    >
      <p
        slot="activator"
        class="mb-0"
      >
        <v-flex
          d-flex
          align-center
        >
          <v-icon color="iconColor">
            event
          </v-icon>
          <span class="pl-2 subheading">
            {{ formattedDate }}
          </span>
        </v-flex>
      </p>
      <v-date-picker
        v-model="date"
        :type="type"
        :min="min"
        :max="max"
        no-title
        scrollable
      >
        <v-spacer />
        <v-btn
          flat
          color="primary"
          @click="menu = false"
        >
          Cancel
        </v-btn>
        <v-btn
          flat
          color="primary"
          @click="_okTap(date)"
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>
<script>
import * as moment from 'moment';

export default {
  model: {
    prop: 'inputDate',
    event: 'change'
  },
  props: {
    inputDate: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: '',
      required: true
    },
    prevNextBtns: {
      type: Boolean,
      default: true
    },
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      menu: false,
      formattedDate: '',
      date: '',
      ISOFormatDate: 'YYYY-MM-DD',
      ISOFormatMonth: 'YYYY-MM',
      prevDisabled: false,
      nextDisabled: false
    };
  },
  watch: {
    inputDate: {
      handler(val) {
        if (!val) return;
        this.date = val;
        this.disableButtons(val);
        this.formatDate(val, this.type);
      },
      immediate: true
    }
  },
  methods: {
    formatDate(date, type) {
      if (type === 'month') {
        this.formattedDate = moment(date, this.ISOFormatMonth).format(
          'MMM YYYY'
        );
      } else if (type === 'date') {
        this.formattedDate = moment(date, this.ISOFormatDate).format(
          'DD MMM YYYY'
        );
        // console.log(this.formattedDate);
      }
    },

    _okTap(val) {
      this.$refs.menu.save(val);
      this.formatDate(val, this.type);

      this.disableButtons(val);

      this.$emit('change', val);
    },

    disableButtons(val) {
      if (val === this.min) {
        this.prevDisabled = true;
      } else if (val === this.max) {
        this.nextDisabled = true;
      } else {
        this.prevDisabled = false;
        this.nextDisabled = false;
      }
    },

    prev() {
      if (this.type === 'month') {
        this.date = moment(this.date, this.ISOFormatMonth)
          .subtract(1, 'months')
          .format(this.ISOFormatMonth);
        this.formattedDate = moment(this.date).format('MMM YYYY');
        this.$emit('change', this.date);
        this.disableButtons(this.date);
      } else if (this.type === 'date') {
        this.date = moment(this.date, this.ISOFormatDate)
          .subtract(1, 'days')
          .format(this.ISOFormatDate);
        this.formattedDate = moment(this.date).format('DD MMM YYYY');
        this.$emit('change', this.date);
        this.disableButtons(this.date);
      }
    },
    next() {
      if (this.type === 'month') {
        this.date = moment(this.date, this.ISOFormatMonth)
          .add(1, 'months')
          .format(this.ISOFormatMonth);
        this.formattedDate = moment(this.date).format('MMM YYYY');
        this.$emit('change', this.date);
        this.disableButtons(this.date);
      } else if (this.type === 'date') {
        this.date = moment(this.date, this.ISOFormatDate)
          .add(1, 'days')
          .format(this.ISOFormatDate);
        this.formattedDate = moment(this.date).format('DD MMM YYYY');
        this.$emit('change', this.date);
        this.disableButtons(this.date);
      }
    }
  }
};
</script>

